import { useEffect, useState } from 'react';

const KEY = 'ul101-quote-list';
const EVT = 'ctrl:quote-list-changed';

export const readQuoteList = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };

export const writeQuoteList = (list) => {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new CustomEvent(EVT));
};

export const addToQuoteList = (items) => {
  const list = readQuoteList();
  Object.entries(items).forEach(([pn, qty]) => { list[pn] = Math.max(list[pn] || 0, qty); });
  writeQuoteList(list);
};

export const useQuoteList = () => {
  const [list, setList] = useState(readQuoteList);
  useEffect(() => {
    const sync = () => setList(readQuoteList());
    const clearAll = (e) => { if (e.detail?.parts) writeQuoteList({}); };
    window.addEventListener(EVT, sync);
    window.addEventListener('storage', sync);
    window.addEventListener('ctrl:quote-submitted', clearAll);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener('storage', sync); window.removeEventListener('ctrl:quote-submitted', clearAll); };
  }, []);
  const toggle = (pn) => { const n = { ...readQuoteList() }; if (n[pn]) delete n[pn]; else n[pn] = 1; writeQuoteList(n); };
  const setQty = (pn, qty) => { const n = { ...readQuoteList() }; if (qty < 1) delete n[pn]; else n[pn] = qty; writeQuoteList(n); };
  const clear = () => writeQuoteList({});
  return { list, toggle, setQty, clear };
};
